import styleFn, {compose} from '../util.js'

const bgColor = styleFn({
  propName: 'bg',
  cssProp: 'background-color',
  systemProp: 'colors'
})

const textColor = styleFn({
  propName: 'color',
  systemProp: 'colors'
})

export default compose(textColor, bgColor)
